import { createGlobalStyle } from 'styled-components';
import { globalScrollbarStyles } from './scrollbarStyles';

/**
 * 全局滚动条样式组件
 * 使用 styled-components 的 createGlobalStyle 创建全局样式
 */
export const GlobalScrollbarStyles = createGlobalStyle`
  ${globalScrollbarStyles}
`;

export default GlobalScrollbarStyles;
